const validateFirstPage = values => {
  const errors = {}
  if (!values.name) {
    errors.name = "A charity name is required."
  }
  if (!values.charityId) {
    errors.charityId = "A charity ID is required."
  }
  if (!values.description) {
    errors.description = "A description is required."
  }
  return errors;
};

const validateSecondPage = values => {
  const errors = {};
  if (!values.displayName) {
    errors.displayName = "A name is required."
  }
  if (!values.role) {
    errors.role = "A role is required."
  }
  if (!values.phone) {
    errors.phone = "A phone number required."
  }
  if (/[a-zA-Z]+/.test(values.phone)) { // TODO proper phone # validation?
    errors.phone = "A valid phone number is required."
  }
  return errors;
};

export { validateFirstPage, validateSecondPage };
